/*
 * Story Theme
 *
 * Use this file to add custom Javascript to Story.  Keeping your custom
 * Javascript in this fill will make it easier to update Story. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

/* Track changes
// 20230102 Custom_001 : surround selected option in product page
// 20230103 custom_002 : detect option selected in product page & update price
// 20230107 Custom_003 : Add Money format handler
// 20231018 Custom_004 : Test if sellingPlan is available on the page to avoid JS errors
// 20250708 Custom_005 : Add cart drawer functionality to handle rentals and purchases
*/

// Custom_001 : surround selected option in product page
function resetBorders() {
  document.getElementById("selling_plan").value = "";
}

function highlightBorderBuy() {
  // 20231018 Custom_004 : Test if sellingPlan is available on the page to avoid JS errors
  if (document.getElementById("buyBox-div") !== null) {
    resetBorders();
    document.getElementById("buyBox-div").classList.add('active');
    document.getElementById("rentBox-div").classList.remove('active');
    document.getElementById("buy-input").checked = true;
    document.getElementById("buyBox-div").querySelector('[data-quantity-input]').disabled = false;
    document.getElementById("rentBox-div").querySelector('[data-quantity-input]').disabled = true;
  }
}

function highlightBorderRent() {
  // 20231018 Custom_004 : Test if sellingPlan is available on the page to avoid JS errors
  if (document.getElementById("buyBox-div") !== null) {
    resetBorders();
    document.getElementById("rentBox-div").classList.add('active');
    document.getElementById("buyBox-div").classList.remove('active');
    document.getElementById("rent-input").checked = true;
    document.getElementById("rentBox-div").querySelector('[data-quantity-input]').disabled = false;
    document.getElementById("buyBox-div").querySelector('[data-quantity-input]').disabled = true;
    document.getElementById("selling_plan").value = findSelectedSellingPlan();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var productHeadline = document.querySelector('.product__headline');
  if (productHeadline && productHeadline.hasAttribute('data-first-line-item-type')) {
    var firstLineItemType = productHeadline.getAttribute('data-first-line-item-type');
    if (firstLineItemType === 'buy') {
      highlightBorderBuy();
    } else {
      highlightBorderRent();
    }
  } else {
    highlightBorderRent();
  }
});

// custom_002 : detect option selected in product page & update price
var sellingPlanContainer = document.querySelector(".selling-plan-fieldset");

function productFormChangeHandler() {
  var selectedVariant = findSelectedVariant();
  var availableSellingPlanAllocations =
      selectedVariant.selling_plan_allocations;
  var selectedSellingPlan = findSelectedSellingPlan();
  var sellingPlanPrice = findSellingPlanPrice(
      selectedVariant,
      selectedSellingPlan
  );
  // Update renting price
  document.getElementById("span-price-rent").innerHTML =
      Shopify.formatMoney(sellingPlanPrice);
  // Update product price
  document.getElementById("span-price-buy").innerHTML = Shopify.formatMoney(
      selectedVariant.price
  );
  if (document.getElementById("buy-input").checked == true) {
    // if buy option selected, id_selling_plan is reseted
    document.getElementById("selling_plan").value = "";
  } else {
    // Update id for shopping cart
    document.getElementById("selling_plan").value = selectedSellingPlan;
  }

  // Update the selling plan option selectors based on the available selling plan allocations
  // for the selected variant
}

// 20231018 Custom_004 : Test if sellingPlan is available on the page to avoid JS errors
if (sellingPlanContainer !== null) {
  /*var product = JSON.parse(sellingPlanContainer.dataset.product);*/
  var product = JSON.parse(document.getElementById("data_script").textContent);
  var productForm = document.querySelector(".shopify-product-form");

  var findSelectedVariant = function () {
    var selectedVariantId = parseInt(
      document.querySelector('.shopify-product-form [name="id"]').value
    );
    var selectedVariant;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === selectedVariantId) {
        selectedVariant = product.variants[i];
        break;
      }
    }

    return selectedVariant;
  };


var findSelectedSellingPlan = function () {
  var selectedSellingPlan = document.getElementById("rent-select");
  var selectedSellingPlanValue = selectedSellingPlan.value;
  return selectedSellingPlanValue;
};

var findSellingPlanPrice = function (variant, sellingPlanId) {
  var sellingPlanPrice;
  for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
    if (variant.selling_plan_allocations[i].selling_plan_id == sellingPlanId) {
      sellingPlanPrice = variant.selling_plan_allocations[i].price;
      break;
    }
  }
  return sellingPlanPrice;
};

// Watch for variant selection to update selling plan option selectors
productForm.addEventListener("change", productFormChangeHandler);

}

// Custom_003 : Add Money format handler
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.money_format = "{{amount}} €";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    var dollarsHtml = '<span class="price_euros">' + dollars.replace(',', '.') + '</span>';
    var centsHtml = cents.replace('.', ',');

    return dollarsHtml + centsHtml;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function () {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Custom_005 : Add cart drawer functionality to handle rentals and purchases
  function handleErrors(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        throw new Error(`Error ${response.status}: ${JSON.stringify(json)}`);
      });
    }
    return response;
  }

  function formatPrice(price) {
    return themeVendor.themeCurrency.formatMoney(price, theme.moneyFormat);
  }

  // Sync contribution price in cart drawer with checkout button
  function syncContributionPriceWithCheckout() {
    const contributionPriceEl = document.getElementById('contribution-price');
    const checkoutBtn = document.querySelector('button.checkout__button');
    if (!contributionPriceEl || !checkoutBtn) return;

    const checkoutText = checkoutBtn.textContent.trim();
    const separator = ' - ';
    const priceText = checkoutText.includes(separator)
      ? checkoutText.split(separator).slice(1).join(separator).trim()
      : checkoutText;

    contributionPriceEl.textContent = priceText;
  }

  function cartStartLoading() {
    const drawerCartLoader = document.querySelector('[data-cart-loading]');
    Array.from(document.querySelectorAll('.cart__items .item--loadbar')).forEach((elt) => {
      elt.style.display = 'block';
    });
    drawerCartLoader.classList.add('cart--loading');
  }

  function cartEndLoading() {
    const drawerCartLoader = document.querySelector('[data-cart-loading]');
    drawerCartLoader.classList.remove('cart--loading');
  }

  const updateItemSellingPlan = async (cart, line, item, sellingPlanName) => {
    if (item.selling_plan_allocation.selling_plan.name !== sellingPlanName) {
      cartStartLoading();
      // We need to fetch the product to get the selling plan ID that matches the selling plan name.
      const product = await fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js').then(response => response.json());
      const sellingPlans = product.selling_plan_groups[0].selling_plans;
      const sellingPlan = sellingPlans.find(plan => plan.name === sellingPlanName);

      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: item.quantity,
          selling_plan: sellingPlan.id,
        }),
      }).then(handleErrors).then(response => response.json()).catch(() => cart);
    }
    return cart;
  };

  const checkCartForRentalsAndPurchases = async (cart) => {
    if (cart.items.length === 0) {
      // Reset lastSellingPlanName when cart is emptied
      lastSellingPlanName = null;
      return;
    }

    const drawerCart = document.querySelector('#drawer-cart');
    const drawerCartErrorCls = 'cart__drawer--error';
    const checkoutBtn = document.querySelector('button.checkout__button');
    const quoteBtn = document.querySelector('button.drawer__quote-btn');
    const checkoutRentalText = checkoutBtn.getAttribute('data-rental-text');
    const checkoutPurchaseText = checkoutBtn.getAttribute('data-purchase-text');
    const checkoutPerMonthText = checkoutBtn.getAttribute('data-per-month-text');
    const updateRentalInfoMessage = drawerCart?.querySelector('[data-drawer-update-rental-info-message]');
    const updateMixedErrorMessage = drawerCart?.querySelector('[data-drawer-update-mixed-error-message]');
    const warningMessage = document.querySelector('[data-drawer-warning-message]');

    if (updateRentalInfoMessage) {
      updateRentalInfoMessage.hidden = true;
    }
    if (updateMixedErrorMessage) {
      updateMixedErrorMessage.hidden = true;
    }
    if (drawerCart) {
      drawerCart.classList.remove(drawerCartErrorCls);
    }

    const cartContainsRentals = cart.items.some(item => item.selling_plan_allocation);
    const cartContainsPurchases = cart.items.some(item => !item.selling_plan_allocation);

    if (warningMessage) {
      const shouldShowWarning = cartContainsRentals;
      warningMessage.hidden = !shouldShowWarning;
      warningMessage.setAttribute('aria-hidden', shouldShowWarning ? 'false' : 'true');
    }

    if (cartContainsRentals && cartContainsPurchases) {
      // If the cart contains both rentals and purchases, disable the checkout.

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = checkoutRentalText;
      if (quoteBtn) {
        quoteBtn.disabled = true;
      }

      if (updateMixedErrorMessage) {
        updateMixedErrorMessage.hidden = false;
      }
      if (drawerCart) {
        drawerCart.classList.add(drawerCartErrorCls);
      }

      cartEndLoading();

    } else if (cartContainsRentals) {
      // If the cart contains only rentals, apply the selling plan of the most recently added item to all items.

      checkoutBtn.disabled = true;
      if (quoteBtn) {
        quoteBtn.disabled = true;
      }

      const lastAddedItem = cart.items.at(0);
      const lastAddedSellingPlanName = lastAddedItem.selling_plan_allocation.selling_plan.name;
      const otherItems = cart.items.slice(1);
      const someItemHasDifferentSellingPlan = otherItems.some(item => item.selling_plan_allocation.selling_plan.name !== lastAddedSellingPlanName);

      // Update lastSellingPlanName when a new item is added
      lastSellingPlanName = lastAddedSellingPlanName;

      let line = 2;
      for (const item of otherItems) {
        cart = await updateItemSellingPlan(cart, line, item, lastAddedSellingPlanName);
        if (item.variant_id !== lastAddedItem.variant_id) {
          // If the item is the last added item, the lines will be merged, so the line number does not need to be incremented.
          line++;
        }
      }

      if (someItemHasDifferentSellingPlan && updateRentalInfoMessage) {
        updateRentalInfoMessage.hidden = false;
      }

      cartEndLoading();

      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = `${checkoutRentalText} - ${formatPrice(cart.original_total_price)}${checkoutPerMonthText}`;
      syncContributionPriceWithCheckout();
      if (quoteBtn) {
        quoteBtn.disabled = false;
      }

    } else {

      checkoutBtn.disabled = false;
      checkoutBtn.textContent = `${checkoutPurchaseText} - ${formatPrice(cart.original_total_price)}`;
      syncContributionPriceWithCheckout();
      if (quoteBtn) {
        quoteBtn.disabled = false;
      }
      cartEndLoading();

    }
  };

  let lastSellingPlanName = null;
  let cartSubtotalObserver = null;

  // Helper function to get the current selling plan name from the cart
  const getCurrentSellingPlanName = async () => {
    // First, try to get it from the select dropdown
    const sellingPlanSelect = document.querySelector('[data-cart-selling-plan]');
    if (sellingPlanSelect && sellingPlanSelect.value) {
      return sellingPlanSelect.value;
    }

    // If not available, fetch from cart API
    try {
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
      if (cart.items.length > 0 && cart.items[0].selling_plan_allocation) {
        return cart.items[0].selling_plan_allocation.selling_plan.name;
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    } 

    // Fallback to last known value
    return lastSellingPlanName;
  };

  const applyCartSellingPlanTextVisibility = (sellingPlanName) => {
    if (!sellingPlanName) return;
    const depositText = document.querySelector('[data-cart-deposit-text]');
    const contributionText = document.querySelector('[data-cart-contribution-text]');
    const depositModalTrigger = document.getElementById('deposit-modal-trigger');
    const contributionModalTrigger = document.getElementById('contribution-modal-trigger');
    const contributionWarning = document.getElementById('drawer-warning-message-contribution');
    const depositWarning = document.getElementById('drawer-warning-message-deposit');

    const setDisplay = (el, value) => {
      if (el) el.style.display = value;
    };

    if (sellingPlanName === '24 mois +' || sellingPlanName === '36 mois') {
      setDisplay(depositText, 'none');
      setDisplay(contributionText, 'block');
      setDisplay(depositModalTrigger, 'none');
      setDisplay(contributionModalTrigger, 'inline-flex');
      setDisplay(contributionWarning, 'block');
      setDisplay(depositWarning, 'none');
    } else {
      setDisplay(depositText, 'block');
      setDisplay(contributionText, 'none');
      setDisplay(depositModalTrigger, 'inline-flex');
      setDisplay(contributionModalTrigger, 'none');
      setDisplay(contributionWarning, 'none');
      setDisplay(depositWarning, 'block'); 
    }
  };

  const initCartSubtotalObserver = () => {
    if (cartSubtotalObserver) {
      cartSubtotalObserver.disconnect();
    }
    const subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
    if (!subtotalEls.length) return;

    cartSubtotalObserver = new MutationObserver(() => {
      // Get the current selling plan name from the select dropdown when subtotal changes
      const sellingPlanSelect = document.querySelector('[data-cart-selling-plan]');
      const currentSellingPlanName = sellingPlanSelect?.value || lastSellingPlanName;
      if (currentSellingPlanName) {
        lastSellingPlanName = currentSellingPlanName;
        applyCartSellingPlanTextVisibility(currentSellingPlanName);
      }
    });

    subtotalEls.forEach((el) => {
      cartSubtotalObserver.observe(el, {childList: true, subtree: true});
    });
  };

  const updateCartSellingPlan = async (sellingPlanName) => {
    const checkoutBtn = document.querySelector('button.checkout__button');
    const quoteBtn = document.querySelector('button.drawer__quote-btn');
    const checkoutRentalText = checkoutBtn.getAttribute('data-rental-text');
    const checkoutPerMonthText = checkoutBtn.getAttribute('data-per-month-text');
    const rentSelect = document.querySelector('#rent-select');

    console.log('Updating cart selling plan to:', sellingPlanName);

    lastSellingPlanName = sellingPlanName;
    applyCartSellingPlanTextVisibility(sellingPlanName);


    
    if (rentSelect) {
      // If the rent select element exists, update its value to the selected selling plan name.
      const matchingOptions = Array.from(rentSelect.options).filter(option => option.text === sellingPlanName);
      if (matchingOptions.length > 0) {
        rentSelect.value = matchingOptions[0].value;
        productFormChangeHandler();
      }
    }

    checkoutBtn.disabled = true;
    if (quoteBtn) {
      quoteBtn.disabled = true;
    }
    cartStartLoading();
    let cart = await fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
    const items = cart.items;
    let line = 1;
    for (const item of items) {
      cart = await updateItemSellingPlan(cart, line, item, sellingPlanName);
      line++;
    }
    cartEndLoading();
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
    checkoutBtn.disabled = false;
    checkoutBtn.textContent = `${checkoutRentalText} - ${formatPrice(cart.original_total_price)}${checkoutPerMonthText}`;
    syncContributionPriceWithCheckout();
    if (quoteBtn) {
      quoteBtn.disabled = false;
    }
  };

  let p = Promise.resolve();
  document.addEventListener(
      'theme:cart:change',
      async (event) => {
        // Promise is used to ensure the cart is fully updated before the next event
        p = p.then(() => checkCartForRentalsAndPurchases(event.detail.cart));
      }
  );

  document.addEventListener(
      'change',
      async (event) => {
        if (event.target.matches('[data-cart-selling-plan]')) {
          const sellingPlanName = event.target.value;
          lastSellingPlanName = sellingPlanName;
          await updateCartSellingPlan(sellingPlanName);
        }
      }
  );

  document.addEventListener(
      'theme:cart:reload',
      async () => {
        initCartSubtotalObserver();
        // Get the current selling plan name from the cart instead of relying on lastSellingPlanName
        const currentSellingPlanName = await getCurrentSellingPlanName();
        if (currentSellingPlanName) {
          lastSellingPlanName = currentSellingPlanName;
          applyCartSellingPlanTextVisibility(currentSellingPlanName);
        } else if (lastSellingPlanName) {
          // Fallback to last known value if we can't get current one
          applyCartSellingPlanTextVisibility(lastSellingPlanName);
        }
        syncContributionPriceWithCheckout();
      }
  );

  initCartSubtotalObserver();
  syncContributionPriceWithCheckout();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
